var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTask({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.1797,
    cy: 19.9062,
    r: 19,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7828 13.1375H22.2618V12.5312C22.2618 12.186 21.9821 11.9062 21.6368 11.9062H16.72C16.3748 11.9062 16.095 12.186 16.095 12.5312V13.1375H14.5742C13.7126 13.1375 13.0117 13.8384 13.0117 14.7V26.3438C13.0117 27.2053 13.7126 27.9062 14.5742 27.9062H23.7828C24.6444 27.9062 25.3453 27.2053 25.3453 26.3438V14.7C25.3453 13.8384 24.6443 13.1375 23.7828 13.1375ZM21.0118 13.1562V14.3688H17.3448C17.3448 13.9534 17.3448 13.6102 17.3448 13.1562H21.0118ZM24.0953 26.3438C24.0953 26.5161 23.9551 26.6562 23.7828 26.6562H14.5742C14.4019 26.6562 14.2617 26.5161 14.2617 26.3438V14.7C14.2617 14.5277 14.4019 14.3875 14.5742 14.3875H16.0948V14.9938C16.0948 15.339 16.3748 15.6188 16.7198 15.6188H21.6368C21.9819 15.6188 22.2618 15.339 22.2618 14.9938V14.3875H23.7828C23.9551 14.3875 24.0953 14.5277 24.0953 14.7V26.3438ZM22.0786 19.2037C22.3228 19.4479 22.3228 19.8436 22.0786 20.0876L18.7942 23.3721C18.5502 23.6162 18.1544 23.6162 17.9103 23.3721L16.2781 21.7399C16.0341 21.4958 16.0341 21.1001 16.2781 20.856C16.5222 20.6119 16.9178 20.6119 17.162 20.856L18.3523 22.0463L21.1947 19.2039C21.4388 18.9597 21.8345 18.9597 22.0786 19.2037Z",
    fill: "#989898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.5da7103edf5b0d193590d21b5dd485df.svg";
export { ForwardRef as ReactComponent };